import { render, staticRenderFns } from "./PublicProfile.vue?vue&type=template&id=471eb38f&scoped=true"
import script from "./PublicProfile.vue?vue&type=script&lang=js"
export * from "./PublicProfile.vue?vue&type=script&lang=js"
import style0 from "./PublicProfile.vue?vue&type=style&index=0&id=471eb38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471eb38f",
  null
  
)

export default component.exports